import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import env from '../../configs/config';
import { observer, inject } from 'mobx-react';
import Divider from '../../components/common/Divider';
import identityService from '../../services/identityService';

const ALLOWED_ROLES = ['admin', 'superadmin'];

class LoginWithMS extends Component {
  constructor(props) {
    super();
    this.state = {};
  }

  componentDidMount = () => {
    const { history } = this.props;
    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');
    const providerError = params.get('error');

    if (providerError) {
      toast.error(decodeURIComponent(providerError), 5);
      params.delete('error');
      const sanitized = params.toString();
      window.history.replaceState({}, document.title, `${window.location.pathname}${sanitized ? `?${sanitized}` : ''}`);
      return;
    }

    if (accessToken) {
      this.finalizeExternalLogin(accessToken, refreshToken);
      return;
    }

    if (
      this.props.applicationStore.isExternalLoggedIn() &&
      !this.props.applicationStore.isLoggedIn() &&
      env['ssocontinueslogin']
    ) {
      this.ConnectAD();
    } else if (this.props.applicationStore.isLoggedIn()) {
      history.push({ pathname: '/welcome' });
    }
  };

  finalizeExternalLogin = async (accessToken, refreshToken) => {
    const { applicationStore } = this.props;
    applicationStore.loading = true;

    try {
      const authResponse = await applicationStore.completeMicrosoftLogin(accessToken, refreshToken || '');
      console.log('Microsoft login authResponse:', authResponse);

      // Role check - parse JWT directly without saving to localStorage yet
      let roles = [];
      try {
        const token = authResponse?.token || authResponse?.Token;
        if (token) {
          const payload = JSON.parse(atob(token.split('.')[1]));
          const ROLE_CLAIM_KEYS = [
            'role', 'roles', 'Role', 'Roles', 'ApplicationRole',
            'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
            'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/role',
          ];
          roles = ROLE_CLAIM_KEYS.reduce((allRoles, key) => {
            const rawValue = payload?.[key];
            if (!rawValue) return allRoles;
            const values = Array.isArray(rawValue) ? rawValue : [rawValue];
            return allRoles.concat(values);
          }, []).filter(Boolean).filter((value, index, source) => source.indexOf(value) === index);
        }
      } catch (e) {
        console.error('Failed to parse roles from Microsoft token:', e);
      }

      const ALLOWED_ROLES = ['admin', 'superadmin'];
      const hasAccess = roles.some((r) => ALLOWED_ROLES.includes((r || '').toLowerCase().replace(/\s/g, '')));
      if (!hasAccess) {
        applicationStore.loading = false;
        toast.error('Access denied. Only Admin and SuperAdmin roles are authorized.', 8000);
        return;
      }

      localStorage.setItem('LoginProvider', 'Microsoft');

      // Clean tokens out of the URL
      const params = new URLSearchParams(window.location.search);
      params.delete('access_token');
      params.delete('refresh_token');
      params.delete('expiration');
      params.delete('is_new_user');
      params.delete('application_id');
      const sanitized = params.toString();
      window.history.replaceState({}, document.title, `${window.location.pathname}${sanitized ? `?${sanitized}` : ''}`);

      // Stay on login page - don't show success toast yet
      // The application selection modal will be shown by onExternalLoginComplete
      // Token is kept in memory until application selection
      applicationStore.loading = false;

      // Show the application selection modal (stay on login page)
      console.log('Calling onExternalLoginComplete callback', this.props.onExternalLoginComplete);
      if (this.props.onExternalLoginComplete) {
        this.props.onExternalLoginComplete(authResponse);
      } else {
        console.warn('onExternalLoginComplete callback not provided!');
      }
    } catch (error) {
      applicationStore.loading = false;
      console.error('Microsoft login error:', error);
      toast.error(error.message || 'SSO login failed. Please reach out to Vizybility IT support', 5);
    }
  };

  ensureSsoShellReady = async () => {
    if (!('serviceWorker' in navigator)) return;
    try {
      await navigator.serviceWorker.register('/sw.js');
      await navigator.serviceWorker.ready;
    } catch (err) {
      console.warn('SSO shell SW prep failed; callback may 404 if SW missing', err);
    }
  };

  ConnectAD = async (e) => {
    if (e) {
      e.preventDefault();
    }
    this.setState({ loading: true });
    this.props.applicationStore.loading = true;

    // The SSO callback URL exceeds IIS query-string limits, so we rely on a
    // service worker to intercept it client-side. Re-register and await active
    // status here in case site data was cleared after page load.
    await this.ensureSsoShellReady();

    const returnUrl = `${window.location.origin}/login`;
    window.location.href = identityService.getExternalProviderLoginUrl('Microsoft', returnUrl);
  };

  render() {
    let loginWithMicrosoft = '';
    if (env['sso']) {
      loginWithMicrosoft = (
        <>
          <Divider className="my-4">or log in with</Divider>
          <Button color="primary" size="sm" block className="mt-2 py-2" onClick={this.ConnectAD}>
            Microsoft
          </Button>
        </>
      );
    } else {
      loginWithMicrosoft = '';
    }
    return <div>{loginWithMicrosoft}</div>;
  }
}

export default withRouter(inject('applicationStore')(observer(LoginWithMS)));
